import { render, staticRenderFns } from "./selectComponent.vue?vue&type=template&id=32804b0e&scoped=true"
import script from "./selectComponent.vue?vue&type=script&lang=js"
export * from "./selectComponent.vue?vue&type=script&lang=js"
import style0 from "./selectComponent.vue?vue&type=style&index=0&id=32804b0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32804b0e",
  null
  
)

export default component.exports